import { NgbDateStruct } from '@cmps/ng-bootstrap';

export interface TdOffersResult {
    resultSet: string;
    params: string;
    periods: string;
}

export interface TdOffersUser {
    userId: number;
    userName: string;
}

export enum TdOffersReportPopulationType {
    Individual = '1',
    SuperGroup = '2',
}

export interface TdOffersReportSelectionParams {
    populationType: TdOffersReportPopulationType;
    populationID: TdOffersUser;
    defaultPopulationID: TdOffersUser;
    startDate: NgbDateStruct;
    endDate: NgbDateStruct;
    invalidEndDate: boolean;
    invalidStartDate: boolean;
    pendingData: boolean;
    noData: boolean;
    invalidUser: boolean;
    isAsc: boolean;
}

export interface TdOffersResultRow {
    product: string;
    totalOffer: string;
    totalYes: string;
    totalNo: string;
    totalMaybe: string;
    offerActionRate: string;
    conversion: string;
}

export interface TdOffersReportResultParams {
    populationType: string;
    populationID: string;
    startDate: string;
    endDate: string;
    dateRequest: string;
    invalidUser: boolean;
}
